import { CUSTOMER_DISCRIMINATOR } from "modules/customers";

const customers = {
  [CUSTOMER_DISCRIMINATOR.MERCHANT]: "Merchant",
  [CUSTOMER_DISCRIMINATOR.PSP]: "Payment service provider",
  [CUSTOMER_DISCRIMINATOR.TSP]: "Technical service provider",
  [CUSTOMER_DISCRIMINATOR.VERIFY]: "Verify",

  "Customer details": "Customer details",
  Country: "Country",
  Parent: "Parent",
  Type: "Type",
  "Merchant Category Code": "Merchant Category Code",
  "Company Registration Number": "Company Registration Number",
  "Document Number": "Document Number",
  "Document Number Label": "Set same value as above",
  "Incorporation Date": "Incorporation Date",
  checkoutBrandingInactiveMessage:
    "Branding is not active, checkout uses default Volt branding",
  companyLogoRequirements: "Please provide images, max. size: {{maxSizeMB}}MB",
  companyLogoRecommendedRatio: "Recommended aspect ratio {{ratio}}",
  overridenAccounts: "{{count}} bank account was overwritten",
  overridenAccounts_plural: "{{count}} bank accounts were overwritten",
};

export default customers;
